import { useToken } from "@gluestack-style/react";
import { SignedIn, SignedOut } from "components/clerk";
import Container from "components/general/Container";
import ScrollContainer from "components/general/ScrollContainer";
import Section from "components/general/Section";
import { Box, H2, Typography, VStack } from "components/ui";
import { Stack } from "expo-router";
import { TriangleAlert } from "lucide-react-native";
import React from "react";

export default function MainLayout() {
	const resolvedPrimaryLight = useToken("colors", "primarylight");
	return (
		<>
			<SignedIn>
				<Stack
					screenOptions={{
						animation: "slide_from_right",
						headerShown: false,
					}}
				>
					<Stack.Screen name="sites/index" />
					<Stack.Screen name="orders/index" />
				</Stack>
			</SignedIn>
			<SignedOut>
				<ScrollContainer>
					<Container sx={{ height: "$full" }}>
						<Section mt={24} flex={1} minHeight="100%" justifyContent="center" alignItems="center">
							<VStack space="md" alignItems="center">
								<Box>
									<TriangleAlert size={48} color={resolvedPrimaryLight} />
								</Box>
								<Box>
									<H2>Access Denied</H2>
								</Box>
								<Box>
									<Typography.Paragraph sx={{ textAlign: "center", color: "$textLight700" }}>Please sign in to access the members area.</Typography.Paragraph>
									<Typography.Paragraph sx={{ textAlign: "center", color: "$textLight700" }}>This section contains exclusive content and features for registered members only.</Typography.Paragraph>
								</Box>

								{/* <Box>
									<Typography.Paragraph sx={{ textAlign: "center", color: "$textLight700" }}>
										Not registered yet?{" "}
										<Button variant="outline" sx={{ paddingVertical: 0, paddingHorizontal: 4, borderWidth: 0 }} onPress={() => router.push("/sign-up")}>
											<Typography.Paragraph sx={{ color: "$primarylight" }}>Create an account</Typography.Paragraph>
										</Button>
									</Typography.Paragraph>
								</Box> */}
							</VStack>
						</Section>
					</Container>
				</ScrollContainer>
			</SignedOut>
		</>
	);
}
